export default __webpack_public_path__ + "static/media/demo_mela.00e79c52.jpg";